var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row full-width justify-end"},[_c('action-show-button',{staticClass:"max-width-100",attrs:{"url":_vm.departmentShowPageLink,"label":"ویرایش"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }